import { Trans } from 'next-i18next'
import React from 'react'
import styled from '@emotion/styled'
import useConfig from '../../../config/state/use-config'
import { TEMPLATE_PLACEHOLDERS } from '../../../../utils/constants/misc'

const Wrapper = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.1px;
  margin-bottom: 10px;
  text-align: justify;
  a {
    color: inherit;
    text-decoration: underline;
    white-space: nowrap;
  }
`

export default function TaxDeductibleMessage() {
  const config = useConfig()

  // Manually interpolate organization name into config message if it contains placeholder
  const getInterpolatedMessage = () => {
    if (!config.taxDeductibleMessage) return null

    let message = config.taxDeductibleMessage

    // Handle FAQ-style placeholder: {{ Non-profit name }}
    if (message.includes(TEMPLATE_PLACEHOLDERS.NON_PROFIT_NAME)) {
      message = message.replace(
        TEMPLATE_PLACEHOLDERS.NON_PROFIT_NAME,
        config.organization?.name || '',
      )
    }

    return message
  }

  const interpolatedMessage = getInterpolatedMessage()

  // If no message is available, don't render anything
  if (!interpolatedMessage && !config.taxDeductibleMessage) {
    return null
  }

  return (
    <Wrapper>
      {interpolatedMessage ? (
        <span>{interpolatedMessage}</span>
      ) : (
        <Trans
          i18nKey="stepFooter.taxDeductibleMessage"
          values={{
            organizationName: config.organization?.name,
          }}
        />
      )}
    </Wrapper>
  )
}
